import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import styled from 'styled-components/macro';

import { getLanguage } from '../../config/i18n';
import { Defaults, px } from '../common';

const DatePickerEx = ({
  value,
  onChange,
  minWidth,
  width,
  height,
  fontSize,
  borderColor,
}: {
  value?: any;
  minWidth?;
  width?;
  height?: number | string;
  fontSize?: number | string;
  borderColor?: string;
  onChange?: (value) => void;
}) => (
  <DateTimePickerRoot
    className={'datepicker'}
    minWidth={minWidth}
    width={width}
    height={height}
    fontSize={fontSize}
    borderColor={borderColor}>
    <DateTimePicker
      calendarClassName={'sky-calendar'}
      value={value}
      onChange={onChange}
      format={localeFormat}
      locale={getLanguage()}
    />
  </DateTimePickerRoot>
);

const localeFormat = getLocaleFormat();

function getLocaleFormat(): string {
  const now = new Date(3333, 10, 22);
  return now
    .toLocaleDateString()
    .replace(/3/g, 'y')
    .replace(/1/g, 'M')
    .replace(/2/g, 'd');
}

const DateTimePickerRoot = styled.div`
  /* font-family: ${Defaults.fontFamily}; */
  font-size: ${(props) => px(props.fontSize || Defaults.fontSize)};

  & .react-datetime-picker__wrapper {
    height: ${(props) => px(props.height)};
    width: ${(props) => px(props.width)};
    border-radius: ${px(Defaults.borderRadius)};
    border: 2px solid ${(props) => props.borderColor};
  }

  & .react-calendar__month-view__days__day {
    color: ${Defaults.fontColor};

    &.react-calendar__month-view__days__day--neighboringMonth {
      color: ${Defaults.grayedFontColor} !important;
    }

    &.react-calendar__month-view__days__day--weekend {
      color: ${Defaults.redColor};
    }
  }

  & .react-calendar__tile--now {
    color: ${Defaults.fontColor} !important;
    background-color: ${Defaults.datePickerNowColor};
  }

  & .react-calendar__tile:hover {
    background-color: ${Defaults.inputsBgColorHover} !important;
  }

  & .react-calendar__month-view__weekdays__weekday {
    color: ${Defaults.fontColor};

    &.react-calendar__month-view__weekdays__weekday--weekend {
      color: ${Defaults.redColor};
    }
  }

  & .react-calendar__navigation > * {
    color: ${Defaults.fontColor};

    &:hover {
      background-color: ${Defaults.inputsBgColorHover} !important;
    }
  }

  & .sky-calendar {
    border: 2px solid ${(props) => props.borderColor};
    background-color: ${Defaults.inputsBgColor};
  }

  & input {
    ${(props) => (props.minWidth ? `min-width: ${px(props.minWidth)};` : '')}
    color: ${Defaults.fontColor};
  }

  & .react-datetime-picker__inputGroup__leadingZero,
  & .react-datetime-picker__inputGroup__divider {
    color: ${Defaults.fontColor};
  }
`;

export default DatePickerEx;
